import React, { useEffect, useState } from 'react';
import { X, User, Mail, Save } from 'lucide-react';
import authService from '../../services/authService';
import './EditProfileDialog.css';

const EditProfileDialog = ({ isOpen, onClose, user, onProfileUpdated }) => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user) {
      setFormData({
        first_name: user.first_name || '',
        last_name: user.last_name || '',
      });
      setError(null);
    }
  }, [user, isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.first_name.trim() || !formData.last_name.trim()) {
      setError('Le prénom et le nom sont obligatoires.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await authService.updateProfile({
        first_name: formData.first_name.trim(),
        last_name: formData.last_name.trim(),
      });

      if (onProfileUpdated) {
        await onProfileUpdated();
      }

      onClose();
    } catch (err) {
      setError(err.response?.data?.error || err.response?.data?.detail || 'Erreur lors de la mise à jour du profil');
    } finally {
      setLoading(false);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget && !loading) {
      onClose();
    }
  };

  return (
    <div className="dialog-overlay ui-dialog-overlay" onClick={handleOverlayClick}>
      <div className="dialog-container ui-dialog-container">
        <div className="dialog-header ui-dialog-header">
          <div className="dialog-title ui-dialog-title">
            <User size={24} />
            <h2>Modifier le profil</h2>
          </div>
          <button className="dialog-close" onClick={onClose} disabled={loading}>
            <X size={20} />
          </button>
        </div>

        {error && <div className="dialog-error">{error}</div>}

        <form className="dialog-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email" className="ui-label">
              <Mail size={16} />
              Email
            </label>
            <input
              type="email"
              id="email"
              value={user?.email || ''}
              readOnly
              className="ui-input"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="first_name" className="ui-label">
                Prénom
              </label>
              <input
                type="text"
                id="first_name"
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                required
                className="ui-input"
                placeholder="Votre prénom"
              />
            </div>

            <div className="form-group">
              <label htmlFor="last_name" className="ui-label">
                Nom
              </label>
              <input
                type="text"
                id="last_name"
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                required
                className="ui-input"
                placeholder="Votre nom"
              />
            </div>
          </div>

          <div className="dialog-actions ui-dialog-actions">
            <button
              type="button"
              className="btn-secondary ui-btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Annuler
            </button>
            <button
              type="submit"
              className="btn-primary ui-btn-primary"
              disabled={loading}
            >
              {loading ? 'Enregistrement...' : (
                <>
                  <Save size={18} />
                  Enregistrer
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProfileDialog;
